import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAffAuth } from "../context/AffAuthContext";
import axios from "axios";
const API = `${(process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "")}/api`;

export default function AffAuthCallback() {
  const navigate = useNavigate();
  const { login } = useAffAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash;
    const sid = new URLSearchParams(hash.substring(1)).get("session_id");
    if (!sid) { navigate("/affiliate/login", { replace: true }); return; }
    (async () => {
      try {
        const res = await axios.post(`${API}/affiliate/auth/session`, { session_id: sid });
        login(res.data.user, res.data.session_token);
        navigate("/affiliate/dashboard", { replace: true });
      } catch { navigate("/affiliate/login", { replace: true }); }
    })();
  }, [navigate, login]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-950">
      <div className="w-8 h-8 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
